import { createMigrate, persistReducer, persistStore } from 'redux-persist'
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'redux-persist/es/constants'
import storage from 'redux-persist/lib/storage'
import { combineReducers, configureStore } from '@reduxjs/toolkit'

import { migrations } from './migrations'
import { dayPlanReducer } from './slices/dayPlanSlice'
import { roleReducer } from './slices/roleSlice'
import { userOptionsReducer } from './slices/userOptionsSlice'

const persistConfig = {
  key: 'root',
  version: 0,
  migrate: createMigrate(migrations),
  storage,
  whitelist: ['userOptions', 'role'],
}

export const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    role: roleReducer,
    userOptions: userOptionsReducer,
    dayPlan: dayPlanReducer,
  }),
)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
